export default function MeasurementPage() {
    return (
        <div style={{
            background: 'linear-gradient(180deg, rgba(52,119,208,1) 0%, rgba(76,198,119,1) 35%, rgba(25,145,114,1) 66%, rgba(0,75,175,1) 100%)',
            minHeight: '100vh',
            width: '100vw'
        }}>
            <div className="p-10 max-w-6xl m-auto pt-20 text-white">
                <h1 className="text-6xl text-center text-white font-bold">
                    Measurement
                </h1>
                <br></br><br></br>
                <h2 className="text-3xl text-center text-white font-bold">
                    <strong>
                        <em>Overview</em>
                    </strong>
                </h2>
                <p className="p">
                    For the characterization of the molecule responsible for sensing EDCs within our biosensor (hER
                    Alpha) we designed the following experimental measurement strategy:
                </p>
                <h2 className="text-xl text-center text-white font-bold">
                    <strong>
                        <em>Strategy 1. IntAssay</em>
                    </strong>
                </h2>
                <p className="p">
                    After researching different ways to measure the functionality of a sensing protein HERα, it was
                    found that the use of intein protein splicing and protein fusion of the former with natural
                    binding-domains can certainly be used to sense synthetic molecules [1][2][3] and leave visible
                    evidence of the functionality of the receptor protein.
                    <br></br><br></br>
                    In our case HERα, and in further research it was found that a iGEM Team UPF Barcelona had done a
                    similar measurement with thyroid hormones as ligand. Then the part BBa_K4260111 was designed, always
                    contemplating the restriction sites established by iGEM. For the improvement of our gene expression
                    and to have an efficient purification of the protein, we established an IPTG induction system and a
                    signal peptide (ompA) [4][5] that led the translation into the periplasmic space along with RBS, a
                    T7 promoter and terminator, synthesized by sponsor IDT.
                    <br></br><br></br>
                    By expressing the part BBa_K4260111 inside pJET 1.2 obtained by ThermofisherⓇ, even though said
                    vector is a cloning one, the sequence already had parts that allowed protein translation, and the
                    advantage of the pJET 1.2/blunt killer switch was taken in account. The DNA sequence was synthesized
                    into separated parts and united by a PCR overlapping and amplified after by PCR using iGEM primers.
                    It was transformed within DH5α strain, the plasmid was extracted and characterized by restriction
                    enzymes, then transformed again in HMS174 strain of E.coli, the reporter gen is meant to be
                    expressed and free amilCP blue chromoprotein to be completed due to the splicing occurring between
                    inteins when an EDC is caught by HERα. The quantity of blue chromoprotein is expected to vary
                    increasingly as the concentration of BPA grows. This variation will be measured by an
                    spectrophotometer, with LB medium as blank and the sample analysis of triplicated E.coli culture
                    exposed to BPA concentrations after induction with IPTG. There was four different BPA concentrations
                    managed in this assay, 1.69 gL,1mgL, 5.5 mgL, 11 mgL , the range of the concentrations included the
                    ones obtain in analysis of wastewater [6] and the concentration at which the mitochondrial complex I
                    decreases [7].
                    <br></br><br></br>
                    The assay divided in three ways to expose the cell to the solution BPA/ethanol, the first being
                    plating 100 L of the solutions in petri dishes, doing triplicates and three negative controls
                    containing ethanol, IPTG and bacteria alone. The second method was the solutions being added to 10
                    mL liquid LB medium with HMS174-BBa_K4260111 induced by IPTG and to observe the results. It was
                    proposed to measure the variations of the intensity of the blue chromoprotein by absorbances at 588
                    nm and then treat them by ANOVA analysis to determine if the BPA concentration is relevant to the
                    blue chromoprotein concentration in the medium. Unfortunately the results were inconclusive due to
                    the lack of protein expression, and the possibility of the inability of the construction to be
                    spliced in the presence of EDCs was considered. In spite of this, different paths were designed to
                    express it better, the sequence was ligated with pET17b expression vector by digesting said vector
                    with ECORI-HF from New England BioLabs cutting in its MCS and then with a blunting enzyme
                    eliminating the sticky ends to avoid scars, provided along with pJET 1.2 kit from Thermofisher, was
                    utilized and the PCR results were ligated with the vector and afterwards transformed in HMS174
                    strain known for its ability to produce proteins from pET vectors.
                    <br></br><br></br>
                    The assays were performed again but improving the biodisponibility of the cells to the BPA solutions
                    and the grown cells inducted were centrifuged, resuspended in buffer and exposed to BPA. A free cell
                    system containing the machinery of BL21 strain, the PCR sequence and EDCs was done. All the assays
                    failed to produce the desired effect of the intein splicing and liberation of blue chromoprotein.
                    The BPA solutions were done with the dutiful precautions and the correct disposal is also ensured by
                    the company BIMAS SC. The specifications of the assay are reported in the protocol book page 35.
                    <br></br><br></br>
                </p>
                <p>
                    <center>
                        <img
                            src="https://static.igem.wiki/teams/4260/wiki/measu-1.jpeg"
                            alt="Fig1-sp"
                            width="700"
                            align="center"
                        />
                    </center>
                </p>
                <br></br><br></br>

                <h2 className="text-xl text-center text-white font-bold">
                    <strong>
                        <em>Strategy 2: Cell Free System</em>
                    </strong>
                </h2>
                <p className="p">
                    Firstly, the BL21 strain was inoculated and incubated overnight in 100 mL of LB+Amp media, when the
                    cells were at an optical density of 0.6, they were induced with IPTG and left overnight; then the
                    cells were centrifuged, and the biomass was resuspended with R1 buffer, lysed with the help of the
                    polytron homogenizer, and the supernatant was recovered containing protein remains and ribosomes.
                    The resulting supernatant can be used to carry protein expression without the need for any
                    transformed living cells since all the machinery needed to express protein such as ribosomes and
                    protein remains are all present in the supernatant. After the cell “extract” was obtained, the RecA
                    mini intein biosensor amplified sequence through PCR was added to the extract for its proper
                    translation and expression, along with EDCs: three solutions were made, one with cell extract, PCR
                    amplified sequence and EDCs, the second without the PCR amplified sequence, and the third without
                    EDCs. The expected result is a change in coloration observed in the first solution, in contrast with
                    the other two, that may serve as negative controls.
                </p><br></br>
                <h2 className="text-l text-left text-white font-bold">
                    <strong>
                        <em>Chitosan beads with ESR1 from periplasm exposed to BPA and CBZ</em>
                    </strong>
                </h2>
                <p className="p">
                    Chitosan is a biocompatible, biodegradable, non-toxic material that provides stability to enzymes
                    and proteins[8] and being the reactive proposed to immobilize our protein in the biosensor, some
                    experiments were done, there are various ways of immobilizing proteins with chitosan, either in
                    beads or enhanced with gold nanoparticle. We decided to implement the experiment for chitosan beads
                    due to its advantages for wastewater treatment such as protection of the protein, pH resistance and
                    free of toxicity. After HERα precipitation following centricons protocol in the protocol book page
                    7, chitosan beads were made with the final sample and chitosan, the protocol book establishes the
                    methodology for the elaboration of the beads, protocol book page 36. After its immobilization with
                    chitosan, ESR1 and the control beads made with distilled water were exposed to BPA and Carbamazepin
                    to analyze its affinity to our sensing protein in chitosan and to be sure that our protein was the
                    one capturing the EDCs and not the chitosan. The samples where it was necessary to quantify protein
                    were measured at 280 nm, in the case of BPA at 290 nm and for Carbamazepin at 284 nm. Samples were
                    taken during the elaboration of the beads to calculate the concentration of HERα during the
                    immobilization and after 12 hrs of exposure to the EDCs.
                </p><br></br>
                <p>
                    <center><img
                        src="https://static.igem.wiki/teams/4260/wiki/measu-2.jpeg"
                        alt="Fig1-sp"
                        width="700"
                        align="center"
                    />
                    </center>
                </p>
                <br></br>
                <p className="p">
                    Chitosan is a biocompatible, biodegradable, non-toxic material that provides stability to enzymes
                    and proteins[8] and being the reactive proposed to immobilize our protein in the biosensor, some
                    experiments were done, there are various ways of immobilizing proteins with chitosan, either in
                    beads or enhanced with gold nanoparticle. We decided to implement the experiment for chitosan beads
                    due to its advantages for wastewater treatment such as protection of the protein, pH resistance and
                    free of toxicity. After HERα precipitation following centricons protocol in the protocol book page
                    7, chitosan beads were made with the final sample and chitosan, the protocol book establishes the
                    methodology for the elaboration of the beads, protocol book page 36. After its immobilization with
                    chitosan, ESR1 and the control beads made with distilled water were exposed to BPA and Carbamazepin
                    to analyze its affinity to our sensing protein in chitosan and to be sure that our protein was the
                    one capturing the EDCs and not the chitosan. The samples where it was necessary to quantify protein
                    were measured at 280 nm, in the case of BPA at 290 nm and for Carbamazepin at 284 nm. Samples were
                    taken during the elaboration of the beads to calculate the concentration of HERα during the
                    immobilization and after 12 hrs of exposure to the EDCs.
                </p><br></br>
                <p className="p">
                    The absorbances are shown below. For glicine the control must be subtracted from the absorbance of
                    the sample due to the interference the glicine makes at 280 nm.
                </p>
                <div className="flex">
                    <div className="flex flex-1 flex-col max-w-lg">
                        <img
                            src="https://static.igem.wiki/teams/4260/wiki/measure-1.png"
                            alt="Figura5" width="500"
                            className="figure"
                            align="right"
                        />
                    </div>
                    <div className="flex flex-1 flex-col max-w-lg">
                        <img
                            src="https://static.igem.wiki/teams/4260/wiki/measure-2.png"
                            alt="Figura5" width="500"
                            className="figure"
                            align="right"
                        />
                    </div>
                </div>
                <div className="flex">
                    <div className="flex flex-1 flex-col max-w-lg">
                        <img
                            src="https://static.igem.wiki/teams/4260/wiki/measure-3.png"
                            alt="Figura5" width="500"
                            className="figure"
                            align="right"
                        />
                    </div>
                    <div className="flex flex-1 flex-col max-w-lg">
                        <img
                            src="https://static.igem.wiki/teams/4260/wiki/measure-4.png"
                            alt="Figura5" width="500"
                            className="figure"
                            align="right"
                        />
                    </div>
                </div>
                <br></br><br></br>
                <p className="p">
                    In order to do a proper interpretation of the results, and to eliminate the effect chitosan has on
                    absorption of BPA and Carbamazepine, the results must be reported as the difference between chitosan
                    with distilled water and chitosan with the protein. There was no significant difference between
                    them, therefore, it was concluded that Carbamazepine was absorbed by chitosan and not by the
                    protein, the subtraction leaves 0 A. In the case of BPA it not was absorbed, neither by the chitosan
                    or the protein
                </p><br></br>
                <div className="flex">
                    <div className="flex flex-1 flex-col max-w-lg">
                        <img
                            src="https://static.igem.wiki/teams/4260/wiki/measure-5.png"
                            alt="Figura5" width="500"
                            className="figure"
                            align="right"
                        />
                    </div>
                    <div className="flex flex-1 flex-col max-w-lg">
                        <img
                            src="https://static.igem.wiki/teams/4260/wiki/measure-6.png"
                            alt="Figura5" width="500"
                            className="figure"
                            align="right"
                        />
                    </div>
                </div>
                <br></br>
                <p className="p">
                    Therefore we conclude that despite the advantages of the chitosan beads for water treatment, coating
                    gold nanoparticles with chitosan is the better option for our bionsensor, hERa embedded in chitosan
                    does not allow interaction with EDCs.
                </p><br></br><br></br>
                <h2 className="text-l text-left text-white font-bold">
                    <strong>
                        <em>Biosensor calibration</em>
                    </strong>
                </h2>
                <p className="p">
                    As any hardware meant to sense, our biosensor will be calibrated by stating a blank sample as
                    distilled water to standardize the volume, that measurement will be stated as frequency shift 0.
                    After that, a calibration curve will be established by exposing the biosensor to different BPA
                    solutions, the solutions before and after the calibration will be measured by HPLC to know the
                    change of concentration in order to correlate it to the shift in frequency registered by the
                    hardware and software.
                </p><br></br>
                <p>
                    <center>
                        <img
                            src="https://static.igem.wiki/teams/4260/wiki/biosensorv2.png"
                            alt="Fig1-sp"
                            width="700"
                            align="center"
                        />
                    </center>
                </p>
                <br></br><br></br>
                <h1 className="text-3xl text-left text-blue font-bold font-blue">References</h1>
                <p className="reference">
                    [1] Gierach, I., Li, J., Wu, W. Y., Grover, G. J., & Wood, D. W. (2012). Bacterial biosensors for
                    screening isoform-selective ligands for human thyroid receptors α-1 and β-1. FEBS open bio, 2,
                    247-253.<br></br>
                    [2] Liang, R., Zhou, J., & Liu, J. (2011). Construction of a bacterial assay for estrogen detection
                    based on an estrogen-sensitive intein. Applied and environmental microbiology, 77(7),
                    2488-2495.<br></br>
                    [3] Buskirk, A. R., Ong, Y. C., Gartner, Z. J., & Liu, D. R. (2004). Directed evolution of ligand
                    dependence: small-molecule-activated protein splicing. Proceedings of the National Academy of
                    Sciences, 101(29), 10505-10510.<br></br>
                    [4] Goulas T, Cuppari A, Garcia-Castellanos R, Snipas S, Glockshuber R, Arolas JL, et al. (2014) The
                    pCri System: A Vector Collection for Recombinant Protein Expression and Purification. PLoS ONE
                    9(11): e112643.https://doi.org/10.1371/journal.pone.0112643<br></br>
                    [5] http://parts.igem.org/Part:BBa_K208003<br></br>
                    [6] Fukazawa, H., Hoshino, K., Shiozawa, T., Matsushita, H., & Terao, Y. (2001). Identification and
                    quantification of chlorinated bisphenol A in wastewater from wastepaper recycling plants.
                    Chemosphere, 44(5), 973-979.<br></br>
                    [7] Ooe H., Taira T., Iguchi-Ariga S. M. and Ariga H. (2005) Induction of reactive oxygen species by
                    bisphenol A and abrogation of bisphenol A-induced cell injury by DJ-1. Toxicol Sci 88,
                    114-26.<br></br>
                    [8] Jaiswal, N., Pandey, V. P., & Dwivedi, U. N. (2016). Immobilization of papaya laccase in
                    chitosan led to improved multipronged stability and dye discoloration. International journal of
                    biological macromolecules, 86, 288-295.<br></br>
                </p>
            </div>
        </div>
    );
}
  